module.exports = __webpack_public_path__ + "img/晨鸟log.4ad23ffe.png";